import React from 'react';
import { meow, network } from '../util/Addresses';

import {
  Link,
  useLocation
} from "react-router-dom";

export default function SideNav(props) {
  const location = useLocation();

  const linkClass =(route) =>
    route === location.pathname ? "strong" : "";

  const networkPrefix = network === 'rinkeby' ? 'rinkeby.' : '';

  return (
    <div className='contentContainer'>
      <div className='sideNav'>
        {' '}
        <small>MeowDAO</small>
        <ul>
          <li>
            <Link className={linkClass("/")} to="/">Home</Link>
          </li>
          <li>
            <Link className={linkClass("/greypaper")} to="/greypaper">Grey Paper</Link>
          </li>
          <li>
            <Link className={linkClass("/reclaim")} to="/reclaim">Reclaim</Link>
          </li>
          <li>
            <Link className={linkClass("/stake")} to="/stake">Stake</Link>
          </li>
          <li>
            <Link className={linkClass("/vote")} to="/vote">Vote</Link>
          </li>
          <li>
            <Link className={linkClass("/votestatus")} to="/votestatus">Vote Status</Link>
          </li>
          <li>
            <a href='http://meow.army' target="_blank" rel="noopener noreferrer">Twitter</a>
          </li>
          <li>
            <a href='http://meow.group' target="_blank" rel="noopener noreferrer">Telegram</a>
          </li>
          <li>
            <a href='http://meow.quest' target="_blank" rel="noopener noreferrer">Discord</a>
          </li>
          <li>
            <a href='http://meow.school' target="_blank" rel="noopener noreferrer">FAQ</a>
          </li>
          <li>
            <a href={`https://${networkPrefix}etherscan.io/token/${meow}`} target="_blank" rel="noopener noreferrer">Etherscan</a>
          </li>
        </ul>
      </div>
      <div className='mainContent'>
        {React.cloneElement(props.children, props)}
      </div>
    </div>
  )
}
